import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GateWayService } from '../../services/gateway-service.service';
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
declare const $:any;

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss','../platform-color/platform-color.scss']
})
export class HomepageComponent implements OnInit {
  form: FormGroup;
  public state: any;
  public title: any;
  public loading: boolean = false;
  public confirmDelete: boolean = false;
  public dropdownOrg: any = [];
  public AllchildOrg: any = [];
  public AllOrg: any = [];
  public orgIndex: number = 0;
  public childOrg: any = [];

  public successDelModal: string = '#successDelModal';
  public delete: any = null;
  public systemRole: string;
  public upload = environment.URL_UPLOAD;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private gwService: GateWayService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
  ) {
    this.state = this.route.snapshot.queryParams["state"];
  }

  async ngOnInit() {
    this.createForm();
    this.spinner.show();
    setTimeout(async () => {
      this.systemRole = localStorage.getItem('system_role');

      await this.getOrg();
    }, 1000);
  }

  createForm(){
    this.form = this.formBuilder.group({
      name: [""]
    });
  }

  async selectChildorg(orgId, childOrgId) {
    let data = {
      orgId: orgId,
      childOrgId: childOrgId
    }
    this.spinner.show();
    await this.gwService.updateSelectedOrg(data)
      .subscribe(success => {

        if (success.code == 200) {
          let org = this.AllOrg.filter(cv => cv._id === orgId)
          let url = org[0].domain_url;
     
          window.location.href = `${url}/preload?code=${success.data}`
        } else {
          this.router.navigate(["/error-page"], { queryParams: { state: this.authService.getState(), errorCode: '00' } }).then(() => {
            localStorage.clear();
            window.location.reload();
          });
        }

        this.spinner.hide();

      });
  }
  async getOrg() {
    await this.gwService.queryORG()
      .subscribe(success => {

        if (success.code == 200) {
          let data = success.data;

          if (data.org.length > 0) {
            data.org.forEach(element => {
              this.dropdownOrg.push({
                name: element.name,
                value: element.id
              })
            });
            this.AllchildOrg = data.childorg.filter(cv=> !cv.status_delete);
            this.AllOrg = data.org;
            
            this.childOrg = this.AllchildOrg.filter(cv => cv.org_id === this.dropdownOrg[0].value)
          }
          this.loading = true
          this.spinner.hide();
        } else {
          this.router.navigate(["/error-page"], { queryParams: { state: this.authService.getState(), errorCode: '00' } }).then(() => {
            localStorage.clear();
            window.location.reload();
          });
        }
      });
  }

  async changeOrg(value) {
    this.spinner.show();
    setTimeout(async () => {
      let orgIndex = this.dropdownOrg.findIndex(cv=> cv.value == value);

      if(orgIndex >= 0){
        this.orgIndex = orgIndex;
      }else{
        this.orgIndex = 0;
      }

      this.childOrg = this.AllchildOrg.filter(cv => cv.org_id === value)
      this.spinner.hide();
    }, 1000);
  }

  search(){
    if(this.form.value.name){
      this.childOrg = this.AllchildOrg.filter(cv => cv.org_id === this.dropdownOrg[this.orgIndex].value && cv.name.toLowerCase().includes(this.form.value.name.toLowerCase()))
    }else{
      this.childOrg = this.AllchildOrg.filter(cv => cv.org_id === this.dropdownOrg[this.orgIndex].value)
    }
  }

  deleteChildOrg(childOrg){
    this.delete = childOrg;
  }

  deleteChildOrgInfo(){
    if(this.delete){
      this.gwService.deleteChildOrg(this.delete.id).subscribe(res=>{
        if(res.code == 200){
          this.delete = null;

          $(this.successDelModal).modal("show");

          this.ngOnInit();
        }
      })
    }
  }
}
